import * as productModules from "@features/product";
import * as seo from "@features/seo/text-generations";
import TechnicalPause from "@features/TechnicalPause/TechnicalPause";
export { TechnicalPause, productModules, seo };